import type { validateQaEnvironment } from "./qa-environment";

const MARKETING_HOSTS_BY_CUSTOMER_HOST: Record<string, readonly string[]> = {
  "ezx-customer-prod.trypreview.app": [
    "ezx-marketing-prod.trypreview.app",
    "tooez.ca",
    "www.tooez.ca",
  ],
  "customer.tooez.ca": [
    "ezx-marketing-prod.trypreview.app",
    "tooez.ca",
    "www.tooez.ca",
  ],
  "ezx-customer-preview.trypreview.app": [
    "ezx-marketing-preview.trypreview.app",
  ],
};

export function resolveMarketingUrl(
  marketingUrl: string | undefined,
  customerUrl: string | undefined,
  development = false,
  qaEnvironment?: ReturnType<typeof validateQaEnvironment>
): string {
  if (!marketingUrl?.trim()) {
    if (development) return "https://ezx-marketing-preview.trypreview.app";
    throw new Error("VITE_MARKETING_URL is required for deployed builds.");
  }

  let marketing: URL;
  try {
    marketing = new URL(marketingUrl.trim());
  } catch {
    throw new Error("VITE_MARKETING_URL must be an absolute site origin.");
  }
  const localHttp =
    development &&
    marketing.protocol === "http:" &&
    ["localhost", "127.0.0.1", "[::1]"].includes(marketing.hostname);
  if (
    (marketing.protocol !== "https:" && !localHttp) ||
    marketing.username ||
    marketing.password ||
    marketing.pathname !== "/" ||
    marketing.search ||
    marketing.hash
  ) {
    throw new Error("VITE_MARKETING_URL must be an HTTPS site origin.");
  }

  if (!customerUrl && development) return marketing.origin;
  let customer: URL;
  try {
    customer = new URL(customerUrl ?? "");
  } catch {
    throw new Error(
      "VITE_AUTH0_CALLBACK_URL is required to validate navigation."
    );
  }
  const expectedHosts =
    qaEnvironment && customer.origin === qaEnvironment.customerOrigin
      ? ["ezx-marketing-preview.trypreview.app"]
      : MARKETING_HOSTS_BY_CUSTOMER_HOST[customer.hostname];
  if (!development && (!expectedHosts || customer.protocol !== "https:")) {
    throw new Error(
      "VITE_AUTH0_CALLBACK_URL must identify a supported deployed customer origin."
    );
  }
  if (expectedHosts && !expectedHosts.includes(marketing.hostname)) {
    throw new Error(
      "VITE_MARKETING_URL must match the customer application's environment."
    );
  }
  return marketing.origin;
}
